import {useCallback, useRef} from 'react';
import {getEditorConfig} from '../../../../../../components/LexicalEditor/editorConfig';
import {EMAIL_EDITOR} from '../../constants';
import {LexicalEditor} from 'lexical';
import {useEmailContext} from '../../../../context';
import {useCustomClipboardCommands} from '../../../../../../components/LexicalEditor/hooks/useCustomClipboardCommands';
import {StyledParagraphNode} from '../../../../../../components/LexicalEditor/nodes/StyledParagrah';
import {emailDialogID} from '../../../../testIDs';

export const useEditor = () => {
    const {
        handlers: {updateEmailEditor, updateEmailHTML, setFocusSubject},
        states
    } = useEmailContext();

    const editorDivRef = useRef<HTMLDivElement>(null);
    const editorRef = useRef<LexicalEditor>();

    const editorConfig = useRef(getEditorConfig(EMAIL_EDITOR, [StyledParagraphNode]));

    const {closeContextMenu, contextMenuComponent, handleContext} = useCustomClipboardCommands({
        editor: editorRef.current,
        portalSelector: emailDialogID
    });

    const setEditorInstance = useCallback(
        (editor: LexicalEditor) => {
            editorRef.current = editor;
            updateEmailEditor(editor);
        },
        [states.language, states.emailEditor]
    );

    return {
        editorDivRef,
        setEditorInstance,
        contextMenuComponent,
        closeContextMenu,
        handleContext,
        editorConfig,
        updateEmailHTML,
        states,
        editorRef,
        setFocusSubject,
        isFromTextEditor: false
    } as const;
};
